// extracted by mini-css-extract-plugin
export var blue = "_3c-f";
export var brand = "_3c-b";
export var darkGrey = "_3c-e";
export var disabled = "_3c-4";
export var disabledSubtle = "_3c-5";
export var error = "_3c-6";
export var green = "_3c-g";
export var grey = "_3c-d";
export var icon = "_3c-0";
export var inherit = "_3c-a";
export var lightGrey = "_3c-c";
export var orange = "_3c-i";
export var pink = "_3c-k";
export var primary = "_3c-1";
export var purple = "_3c-l";
export var red = "_3c-j";
export var secondary = "_3c-2";
export var success = "_3c-9";
export var tertiary = "_3c-3";
export var warning = "_3c-7";
export var warningSecondary = "_3c-8";
export var white = "_3c-m";
export var yellow = "_3c-h";